import React from 'react';
export const ModulesSection = () => {
  const modules = [{
    color: 'border-biosync-azul',
    badgeColor: 'bg-biosync-azul',
    badgeText: 'MÓDULO 0',
    icon: '⚡',
    name: 'System Boot',
    subtitle: 'El Re-Inicio',
    desc: 'Neurociencia del cerebro adolescente · Diagnóstico de bugs emocionales · Semáforo BIO-SYNC · Punto de partida del sistema'
  }, {
    color: 'border-biosync-menta',
    badgeColor: 'bg-biosync-menta',
    badgeText: 'MÓDULO 1',
    icon: '🌊',
    name: 'Bio-Calma',
    subtitle: 'Desactivando el Protocolo de Pánico',
    desc: '3 protocolos de calma en 60 segundos · Fichas de emergencia · Nervio vago · Diario de 21 días'
  }, {
    color: 'border-biosync-amarillo',
    badgeColor: 'bg-biosync-amarillo',
    badgeText: 'MÓDULO 2',
    icon: '🔥',
    name: 'Bio-Control',
    subtitle: 'Dominando el Botón de Pánico',
    desc: 'Cortafuegos de 5 Pasos · Mapa de triggers · Simulador de respuestas · Log de 21 días'
  }, {
    color: 'border-biosync-lavanda',
    badgeColor: 'bg-biosync-lavanda',
    badgeText: 'MÓDULO 3',
    icon: '💎',
    name: 'Bio-Sync',
    subtitle: 'Reparando el Espejo Distorsionado',
    desc: 'Autoestima sólida · Escáner de Realidad · Código de Valor Propio · 30 días de calibración'
  }, {
    color: 'border-biosync-rosa',
    badgeColor: 'bg-biosync-rosa',
    badgeText: 'MÓDULO 4',
    icon: '🔗',
    name: 'Conexión',
    subtitle: 'Configurando tu Firewall Social',
    desc: 'Semáforo de Vínculos · CNV · Mapa de relaciones · Firewall Social configurado'
  }, {
    color: 'border-biosync-durazno',
    badgeColor: 'bg-biosync-durazno',
    badgeText: 'MÓDULO 5',
    icon: '🚀',
    name: 'Upgrade',
    subtitle: 'Tu Rutina de Sincronización Diaria',
    desc: 'Rutina de 5 minutos · Plan de 30 días integrado · Recalibración mensual · Graduación'
  }];
  return <section className="bg-biosync-bgAlt py-10 px-5 sm:px-10" data-id="element-198">
      <div className="max-w-[1100px] mx-auto" data-id="element-199">
        <div className="text-center mb-12" data-id="element-200">
          <h2 className="text-3xl sm:text-4xl font-bold text-biosync-text mb-4" data-id="element-201">
            "📚 LOS 6 MÓDULOS —<br className="hidden sm:block" data-id="element-202" /> Para
            adolescentes de todas las edades"
          </h2>
          <p className="text-biosync-textSec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-203">
            "Cada módulo es un sistema completo de 30 páginas con teoría,
            protocolos, actividades, diario guiado y bibliografía."
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-204">
          {modules.map((mod, i) => <div key={i} className={`bg-white border-2 ${mod.color} rounded-2xl p-6 shadow-sm flex flex-col h-full`} data-id="element-205">
              <div className="flex items-start justify-between mb-4" data-id="element-206">
                <span className={`${mod.badgeColor} text-biosync-text font-bold uppercase text-xs py-1.5 px-3 rounded-full`} data-id="element-207">
                  {mod.badgeText}
                </span>
                <span className="text-3xl" data-id="element-208">{mod.icon}</span>
              </div>
              <h3 className="text-xl font-bold text-biosync-text mb-1" data-id="element-209">
                {mod.name}
              </h3>
              <h4 className="text-sm font-semibold text-biosync-textSec mb-4" data-id="element-210">
                {mod.subtitle}
              </h4>
              <p className="text-biosync-textSec text-sm mt-auto leading-relaxed" data-id="element-211">
                {mod.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};